// selectors

export const getMyCalendarUpcomingEvents = state => {
  return state.MyCalendar.myCalendarUpcomingEvents;
};

export const getMyCalendarEvents = state => {
  return state.MyCalendar.myCalendarEvents;
};

export const getMyCalendarEventsChunk = state => {
  return state.MyCalendar.myCalendarEventsChunk;
};
